import React from "react";
// import * as Icon from "@mui/icons-material";

export const SidebarData = [
  {
    title: "Home",
    icon: <i className="fa-solid fa-house-user fa-xl"></i>,
    link: "/home",
  },
  {
    title: "Bills",
    icon: <i className="fa-solid fa-money-bill fa-xl"></i>,
    link: "/bills",
  },
  {
    title: "About",
    icon: <i className="fa-solid fa-circle-info fa-xl"></i>,
    link: "/about",
  },
  {
    title: "Contact",
    icon: <i className="fa-solid fa-address-card fa-xl"></i>,
    link: "/contact",
  },
];
